var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-4 bg-light mt-auto"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between small"},[_c('div',{staticClass:"text-muted"},[_vm._v("\n                    Copyright © Mimo & Ponto 2019\n                ")]),_vm._v(" "),_c('div')])])])
}]

export { render, staticRenderFns }